export default "__VITE_ASSET__BZUoGX78__"